import PropTypes from 'prop-types';
import { Component } from 'react';
import FormattedMessage from 'I18n/components/FormattedHTMLMessage';
import H2 from 'UIComponents/elements/headings/H2';
import UIButton from 'UIComponents/button/UIButton';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIModal from 'UIComponents/dialog/UIModal';
import UILink from 'UIComponents/link/UILink';
import UIList from 'UIComponents/list/UIList';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class SelfDeletionBlockedModal extends Component {
  renderEditLinks() {
    const {
      singleAdminHubs
    } = this.props;
    if (singleAdminHubs.length === 1) {
      return /*#__PURE__*/_jsx(UILink, {
        href: `/settings/${singleAdminHubs[0]}/users`,
        external: true,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "userPreferences.selfDeleteBlocked.manageUsers"
        })
      });
    }
    return singleAdminHubs.map(portalId => {
      return /*#__PURE__*/_jsx(UILink, {
        external: true,
        href: `/settings/${portalId}/users`,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "userPreferences.selfDeleteBlocked.manageUsersForAccount",
          options: {
            portalId
          }
        })
      }, portalId);
    });
  }
  render() {
    const {
      singleAdminHubs,
      onCloseModal
    } = this.props;
    const descriptionLangKey = singleAdminHubs.length === 1 ? 'singleDescription' : 'multiDescription';
    return /*#__PURE__*/_jsxs(UIModal, {
      use: "danger",
      onEsc: onCloseModal,
      children: [/*#__PURE__*/_jsx(UIDialogHeader, {
        children: /*#__PURE__*/_jsx(H2, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "userPreferences.selfDeleteBlocked.modalHeader"
          })
        })
      }), /*#__PURE__*/_jsxs(UIDialogBody, {
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: `userPreferences.selfDeleteBlocked.${descriptionLangKey}`
        }), /*#__PURE__*/_jsx(UIList, {
          styled: true,
          className: "m-top-4",
          children: this.renderEditLinks()
        })]
      }), /*#__PURE__*/_jsxs(UIDialogFooter, {
        children: [/*#__PURE__*/_jsx(UIButton, {
          use: "danger",
          disabled: true,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "userPreferences.selfDeleteBlocked.confirm"
          })
        }), /*#__PURE__*/_jsx(UIButton, {
          use: "secondary",
          onClick: onCloseModal,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "userPreferences.selfDeleteBlocked.cancel"
          })
        })]
      })]
    });
  }
}
SelfDeletionBlockedModal.propTypes = {
  onCloseModal: PropTypes.func.isRequired,
  singleAdminHubs: PropTypes.array.isRequired
};